import { Trans } from 'next-i18next/pages';
import { ReactNode } from 'react';

interface SectionCardProps {
  children: ReactNode;
  titleI18nKey?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({ children, titleI18nKey }) => (
  <div className='rounded-2xl bg-white p-4 md:p-12'>
    {titleI18nKey && (
      <h2 className='text-default mb-4 text-lg font-bold md:mb-7 md:text-2xl'>
        <Trans
          components={{ span: <span className='font-handwriting text-primary text-2xl font-normal md:text-3xl' /> }}
          i18nKey={titleI18nKey}
        />
      </h2>
    )}
    {children}
  </div>
);

export default SectionCard;
